import {combineReducers} from '@reduxjs/toolkit';
import {mystesApi, nodeApi} from "../api";

export const rootReducer = combineReducers({
  [mystesApi.reducerPath]: mystesApi.reducer,
  [nodeApi.reducerPath]: nodeApi.reducer
});
